import { render, staticRenderFns } from "./card-logo.vue?vue&type=template&id=926af6b6&"
import script from "./card-logo.vue?vue&type=script&lang=js&"
export * from "./card-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports